import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import ProtectedRoute from "services/ProtectedRoutes";
import SessionExpired from "views/auth/SessionExpired";
import CustomerLayout from "layouts/frontend";
import TicketDetails from "views/admin/tickets/components/TicketDetails";
import ProfileLayout from "layouts/profile";

const App = () => {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route
          path="/*"
          element={
            // <ProtectedRoute>
            <CustomerLayout />
            // </ProtectedRoute>
          }
        />

        <Route
          path="admin/*"
          element={
            <ProtectedRoute allowedRoles={["admin", "agent"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        />

        <Route
          path="profile/*"
          element={
            <ProtectedRoute>
              <ProfileLayout />
            </ProtectedRoute>
          }
        />

        <Route
          path="/tickets/:id"
          element={
            <ProtectedRoute>
              <TicketDetails />
            </ProtectedRoute>
          }
        />

        <Route path="auth/*" element={<AuthLayout />} />
        <Route path="session-expired" element={<SessionExpired />} />

        <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
      </Routes>
    </>
  );
};

export default App;
